import { Button, Form, List, Modal, Select, Upload } from 'antd';
import React, { useState } from 'react';
import IntlMessage from '../../components/IntlMessage';
import { SupplierStatus } from '../../utils/constant';
import { UploadOutlined } from '@ant-design/icons';
import orderApi from '../../api/order';

const ModalSupplierStatus = (props) => {
  const { open, onClose, onReload, currentData } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handelSubmit = () => {
    form.validateFields().then(async (values) => {
      setLoading(true);
      const formData = new FormData();
      console.log('values', values);
      formData.append('voucher', values.voucher[0].originFileObj);
      formData.append('supplier_status', values?.supplier_status);

      await orderApi
        .UpdateSupplierStatusAndVoucher(currentData?.id, formData)
        .then((res) => {
          setLoading(false);
          onReload();
          handleCancel();
        })
        .catch(setLoading(false));
      setLoading(false);
    });
  };

  const onFinishFailed = (error) => {
    console.error(error);
  };

  const handleCancel = () => {
    onClose();
  };
  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      width={'80%'}
      title={<IntlMessage id="global.edit" />}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          {<IntlMessage id="global.cancel" />}
        </Button>,
        <Button
          key="save"
          loading={loading}
          type="primary"
          onClick={handelSubmit}
        >
          {<IntlMessage id="global.save" />}
        </Button>,
      ]}
    >
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        layout="horizontal"
        labelAlign="left"
        form={form}
        autoComplete={false}
        onFinish={handelSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name={'supplier_status'}
          label={<IntlMessage id="global.supplier_status" />}
          rules={[
            {
              required: true,
              message: <IntlMessage id="global.requiredfield" />,
            },
          ]}
          initialValue={currentData?.supplier_status}
        >
          <Select>
            {Object.entries(SupplierStatus).map(([key, value]) => {
              return <Select.Option value={value?.status}>{key}</Select.Option>;
            })}
          </Select>
        </Form.Item>
        <Form.Item
          name="voucher"
          label={<IntlMessage id="global.voucher" />}
          valuePropName="fileList"
          getValueFromEvent={(e) => e.fileList}
          rules={[
            {
              required: false,
              message: <IntlMessage id="global.requiredfield" />,
            },
          ]}
        >
          <Upload
            beforeUpload={() => false}
            maxCount={1}
            listType="text"
            accept=".pdf"
          >
            <Button icon={<UploadOutlined />}>Select a pdf file</Button>
          </Upload>
        </Form.Item>
        {currentData.file_voucher && (
          <List
            style={{ marginTop: 16 }}
            bordered
            dataSource={[currentData.file_voucher]}
            renderItem={(item) => (
              <List.Item>
                <a
                  href={currentData.file_voucher}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ width: '100%' }}
                >
                  invoice_{currentData.invoice_no}
                </a>
              </List.Item>
            )}
          />
        )}
      </Form>
    </Modal>
  );
};

export default ModalSupplierStatus;
